import { INDEX } from './types';

/**
 * Retrieve the base CPT or CPM including discount based on a 2D array representation
 * of the 'Pricing' Google Sheet.
 *
 * @param pricingSheet 2D array representation of the 'Pricing' sheet
 * @returns Base CPT or CPM price including discount
 */
const getAdMirroringLoading = (
  adMirroringSheet: Array<Array<any>>,
  demographic: string
): number => {
  const rowIndex = getRowIndex(adMirroringSheet, demographic);
  if (rowIndex === INDEX.NOT_FOUND) return 0;

  return adMirroringSheet[rowIndex][1];
};

const getRowIndex = (
  pricingSheet: Array<Array<any>>,
  demographic: string
): number => {
  return pricingSheet.findIndex(
    (row: Array<any>) => row[INDEX.DEMOGRAPHIC] === demographic
  );
};

export default getAdMirroringLoading;
